import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { DailyDateRangeSelectorComponent } from '../daily-date-range-selector/daily-date-range-selector.component';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, FormControl, ValidationErrors, ControlContainer, NgForm } from '@angular/forms';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-select-period-dialog',
  templateUrl: './select-period-dialog.component.html',
  styleUrls: ['./select-period-dialog.component.css']
})

export class SelectPeriodDialogComponent implements OnInit {

  @ViewChild("dateRangeSelector") dateRangeSelector: DailyDateRangeSelectorComponent;

  beginDate: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);
  endDate: BehaviorSubject<Date> = new BehaviorSubject<Date>(null);

  beginDateSubscription: Subscription;
  endDateSubscription: Subscription;

  dateBoundsSelectionForm: FormGroup;
  useOldDataForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private cdr: ChangeDetectorRef, public dialogRef: MatDialogRef<SelectPeriodDialogComponent>) { }

  ngOnInit(): void {
    this.dateBoundsSelectionForm = this.formBuilder.group({
    });
    this.useOldDataForm = this.formBuilder.group({
      'useOldInjectionValues': [true, []]
    });
  }

  ngAfterViewInit(): void {
    this.initDateBoundsSelectionForm();
    this.cdr.detectChanges();
  }

  initDateBoundsSelectionForm() {
    this.dateBoundsSelectionForm.addControl('dateBoundsSelectionForm', this.dateRangeSelector.dateBoundsSelectionForm);

    this.beginDateSubscription = this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("BeginDate").valueChanges.subscribe((newvalue) => {
      this.beginDate.next(newvalue);
    });

    this.endDateSubscription = this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("EndDate").valueChanges.subscribe((newvalue) => {
      this.endDate.next(newvalue);
    });

    //We have to manually grab these values initially.
    this.beginDate.next(this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("BeginDate").value);
    this.endDate.next(this.dateBoundsSelectionForm.controls.dateBoundsSelectionForm.get("EndDate").value);
  }


  btnClicked(name) {
    if (name == 'Cancel') {
      this.dialogRef.close(null);
    }
    if (name == 'Create') {
      let result = {
        beginDate: this.beginDate.value,
        endDate: this.endDate.value,
        useLastInjData: this.useOldDataForm.value.useOldInjectionValues
      }
      this.dialogRef.close(result);
    }
  }

}
